(function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("leaflet"), require("leaflet.markercluster"), require("vue2-leaflet")) : "function" == typeof define && define.amd ? define(["leaflet", "leaflet.markercluster", "vue2-leaflet"], t) : "object" == typeof exports ? exports.Vue2LeafletMarkercluster = t(require("leaflet"), require("leaflet.markercluster"), require("vue2-leaflet")) : e.Vue2LeafletMarkercluster = t(e.leaflet, e["leaflet.markercluster"], e["vue2-leaflet"]);
})(this, function (e, t, r) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    var r = {};
    return t.m = e, t.c = r, t.i = function (e) {
      return e;
    }, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "/", t(t.s = 7);
  }([function (e, t, r) {
    var n = r(2)(r(1), r(3), null, null);
    e.exports = n.exports;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(5),
      o = r(6),
      u = r(4),
      a = {
        options: {
          type: Object,
          default: function () {
            return {};
          }
        }
      };
    t.default = {
      props: a,
      data: function () {
        return {
          ready: !1
        };
      },
      mounted: function () {
        var e = this;
        this.mapObject = new n.MarkerClusterGroup(this.options), u.DomEvent.on(this.mapObject, this.$listeners), (0, o.propsBinder)(this, this.mapObject, a), this.ready = !0, this.parentContainer = (0, o.findRealParent)(this.$parent), this.parentContainer.addLayer(this), this.$nextTick(function () {
          e.$emit("ready", e.mapObject);
        });
      },
      beforeDestroy: function () {
        this.parentContainer.removeLayer(this);
      },
      methods: {
        addLayer: function (e, t) {
          t || this.mapObject.addLayer(e.mapObject);
        },
        removeLayer: function (e, t) {
          t || this.mapObject.removeLayer(e.mapObject);
        }
      }
    };
  }, function (e, t) {
    e.exports = function (e, t, r, n) {
      var o,
        u = e = e || {},
        a = typeof e.default;
      "object" !== a && "function" !== a || (o = e, u = e.default);
      var i = "function" == typeof u ? u.options : u;
      if (t && (i.render = t.render, i.staticRenderFns = t.staticRenderFns), r && (i._scopeId = r), n) {
        var f = i.computed || (i.computed = {});
        Object.keys(n).forEach(function (e) {
          var t = n[e];
          f[e] = function () {
            return t;
          };
        });
      }
      return {
        esModule: o,
        exports: u,
        options: i
      };
    };
  }, function (e, t) {
    e.exports = {
      render: function () {
        var e = this,
          t = e.$createElement;
        return (e._self._c || t)("div", {
          staticStyle: {
            display: "none"
          }
        }, [e.ready ? e._t("default") : e._e()], 2);
      },
      staticRenderFns: []
    };
  }, function (e, t) {
    e.exports = require("leaflet");
  }, function (e, t) {
    e.exports = require("leaflet.markercluster");
  }, function (e, t) {
    e.exports = require("vue2-leaflet");
  }, function (e, t, r) {
    e.exports = r(0);
  }]);
});